import { useEffect, useState, RefObject } from "react";

export const useScrollPosition = (
  listen: boolean = true,
  elementRef?: RefObject<HTMLElement>,
) => {
  const [windowScrollY, setWindowScrollY] = useState<number>(
    typeof window !== "undefined" ? window.scrollY : 0,
  );
  const [prevWindowScrollY, setPrevWindowScrollY] = useState<number>(
    typeof window !== "undefined" ? window.scrollY : 0,
  );
  const [elementDOMRect, setElementDOMRect] = useState<DOMRect | undefined>(
    elementRef?.current?.getBoundingClientRect(),
  );
  const [isListening, setIsListening] = useState<boolean>(listen);

  useEffect(() => {
    let ticking: boolean = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setWindowScrollY((prev: number) => {
            setPrevWindowScrollY(prev);
            return window.scrollY;
          });
          if (elementRef?.current) {
            setElementDOMRect(elementRef.current.getBoundingClientRect());
          }
          ticking = false;
        });

        ticking = true;
      }
    };
    if (isListening) {
      window.addEventListener("scroll", handleScroll);
    }
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isListening, elementRef]);

  const position: {
    windowScrollY: number;
    prevWindowScrollY: number;
    elementDOMRect?: DOMRect | undefined;
  } = {
    windowScrollY,
    prevWindowScrollY,
  };
  if (elementRef) {
    position.elementDOMRect = elementDOMRect;
  }
  return {
    ...position,
    setIsListening,
  };
};
